interface Props {
  orientation: 'vertical' | 'horizontal';
  onToggle: () => void;
  visible: boolean;
}

export function LayoutOrientationToggle({ orientation, onToggle, visible }: Props) {
  if (!visible) return null;

  const isVertical = orientation === 'vertical';

  return (
    <button
      className="topbar-icon-btn"
      onClick={onToggle}
      title={isVertical ? 'Switch to horizontal layout' : 'Switch to vertical layout'}
    >
      {isVertical ? (
        // Columns icon — side-by-side (vertical graph mode)
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <rect x="1" y="2" width="5" height="12" rx="1" />
          <rect x="8" y="2" width="7" height="12" rx="1" />
        </svg>
      ) : (
        // Rows icon — stacked (horizontal graph mode)
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <rect x="1" y="1" width="14" height="5" rx="1" />
          <rect x="1" y="8" width="14" height="7" rx="1" />
        </svg>
      )}
    </button>
  );
}
